import React, { forwardRef } from 'react';
import Button from 'chameleon/ui-stack/ui/base/button';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';

import './EditorTitle.scss';

const EditorTitle = forwardRef(
  (
    {
      onChange,
      onSubmit,
      value,
      isDisabled,
      onCancelClick = () => {},
      isAuthoringNewPage,
    },
    ref,
  ) => {
    return (
      <form
        className="chunky-form"
        onSubmit={(e) => {
          e.preventDefault();
          !isDisabled && onSubmit();
        }}
      >
        <input
          className="border border-gray-400 rounded-full text-base py-10 text-18
         px-10 mr-10 text-default focus:border-gray-900 h-16 w-full"
          value={value}
          disabled={isDisabled}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Give your question a descriptive title. Students will see this title on their reports."
          ref={ref}
        />

        <Button
          disabled={isDisabled}
          isSuccess
          className="px-10"
          type="submit"
          size="custom"
        >
          Publish
        </Button>

        <ButtonWithIcon
          disabled={isDisabled}
          onClick={onCancelClick}
          isDangerOutline
          className="margin-left-20 px-10"
          size="custom"
          icon="xmark"
        >
          {isAuthoringNewPage ? 'Clear' : 'Cancel'}
        </ButtonWithIcon>
      </form>
    );
  },
);

EditorTitle.defaultProps = {
  onChange: () => {},
  onSubmit: () => {},
};

export default EditorTitle;
